import script from "./SocketStatusBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocketStatusBanner.vue?vue&type=script&setup=true&lang=ts"

import "./SocketStatusBanner.vue?vue&type=style&index=0&id=e47323fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e47323fe"]])

export default __exports__